import React, { FC, useState } from "react";
import { t } from "i18next";
import { vocative } from "czech-vocative";
import _ from "lodash";

import WelcomeBanner from "@components/common/WelcomeBanner";
import { useUserStore } from "@store/user";
import { Grid } from "@components/base";

interface HomeWelcomeBannerInterface {}

const HomeWelcomeBanner: FC<HomeWelcomeBannerInterface> = () => {
  const [show, setShow] = useState(true);
  const { user } = useUserStore();

  const onClose = (): void => {
    setShow(false);
  };

  const getGreeting = (): string => {
    const currentHour = new Date().getHours();

    switch (true) {
      case currentHour < 6:
        return t("home.welcome");
      case currentHour < 12:
        return t("home.goodMorning");
      case currentHour < 18:
        return t("home.goodAfternoon");
      default:
        return t("home.goodEvening");
    }
  };

  const getUserName = (): string => {
    if (user && user?.localizationLanguage === 0) {
      return _.capitalize(vocative(user?.firstName));
    } else {
      return user?.firstName || t("home.user");
    }
  };

  return show ? (
    <Grid size={12}>
      <WelcomeBanner
        color="blue"
        title={`${getGreeting()}, ${getUserName()}!`}
        text={t("home.welcomeText")}
        icon="globe"
        onClose={onClose}
      />
    </Grid>
  ) : null;
};

export default HomeWelcomeBanner;
